import type { CSSProperties } from 'react';
import {
    CircleAlert,
    CircleCheck,
    Info,
    LoaderCircle,
    TriangleAlert,
    X,
} from 'lucide-react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
    return (
        <Sonner
            theme="dark"
            className="toaster group font-sans"
            position="bottom-left"
            style={
                {
                    '--normal-bg': '#000000',
                    '--normal-text': '#ededed',
                    '--normal-border': 'rgba(255, 255, 255, 0.12)',
                    '--border-radius': '0px',
                    fontFamily: 'var(--font-sans)',
                } as CSSProperties
            }
            toastOptions={{
                classNames: {
                    toast:
                        'group toast rounded-none border-white/12 bg-black text-[#ededed] shadow-none font-sans text-[13px]',
                    title: 'font-medium tracking-tight text-[#ededed]',
                    description: 'text-white/45',
                    closeButton:
                        'rounded-none border-white/15 bg-black text-white/60 hover:bg-white/[0.06] hover:text-white',
                    success: '[&_[data-icon]]:text-emerald-400',
                    error: '[&_[data-icon]]:text-red-400',
                    warning: '[&_[data-icon]]:text-amber-300',
                    info: '[&_[data-icon]]:text-brand',
                    icon: 'size-4',
                },
            }}
            icons={{
                success: <CircleCheck className="size-4" />,
                info: <Info className="size-4" />,
                warning: <TriangleAlert className="size-4" />,
                error: <CircleAlert className="size-4" />,
                loading: <LoaderCircle className="size-4 animate-spin" />,
                close: <X className="size-3.5" />,
            }}
            {...props}
        />
    );
};

export { Toaster };
